module.exports = __webpack_public_path__ + "img/icon_task.567b3b0.svg";